import { get } from "../../service/api";

const GetMerchantPermissions = async (id) => {
  try {
    const response = await get(`/merchant/${id}/permissions`);
    return response;
  } catch (error) {
    console.error("Error GetMerchantPermissions:", error);
    throw error;
  }
};

export default GetMerchantPermissions;
